var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEllipsisIconLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 4,
    viewBox: "0 0 16 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66861 1.8343C3.66861 2.84571 2.84692 3.66861 1.8343 3.66861C0.822903 3.66861 0 2.84692 0 1.8343C0 0.822902 0.821688 0 1.8343 0C2.84571 0 3.66861 0.822872 3.66861 1.8343Z",
    fill: "#1D1D1D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.8345 1.8343C9.8345 2.84571 9.01281 3.66861 8.0002 3.66861C6.9888 3.66861 6.16589 2.84692 6.16589 1.8343C6.16589 0.822902 6.98758 0 8.0002 0C9.0116 0 9.8345 0.822872 9.8345 1.8343Z",
    fill: "#1D1D1D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 1.8343C16 2.84689 15.1783 3.66861 14.1657 3.66861C13.1531 3.66861 12.3314 2.84692 12.3314 1.8343C12.3314 0.821688 13.1531 0 14.1657 0C15.1783 0 16 0.821688 16 1.8343Z",
    fill: "#1D1D1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipsisIconLarge);
export default __webpack_public_path__ + "static/media/ellipsis_icon_large.dcf669b29c5d18c2f5e2a14555f0dd36.svg";
export { ForwardRef as ReactComponent };